import { Web3Wallet as Client } from "./client";

export * from "./constants";
export * from "./types";

export const Web3Wallet = Client;
export default Client;
